import { motion } from "framer-motion";
import { GALLERY } from "../data/content";

export const Gallery = () => (
  <section id="hakkimizda" data-testid="gallery-section" className="bg-[#EFECE6] py-24 md:py-32 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center mb-16 md:mb-20">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-[#B85C38] mb-5">{GALLERY.overline}</p>
          <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight leading-none text-[#16281D] mb-6">
            {GALLERY.title}
          </h2>
          <p className="text-[#4A5D52] leading-relaxed max-w-xl">
            Dış cepheden bekleme alanlarına, muayene ve bakım odalarına kadar merkezimizi yakından tanıyın.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="lg:col-span-5"
        >
          <div className="relative aspect-[4/5] max-h-[580px] overflow-hidden rounded-2xl border border-[#16281D]/10 bg-[#E4E1DA]">
            <img
              src={GALLERY.featured.src}
              alt={GALLERY.featured.alt}
              data-testid="gallery-featured"
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-[1.03]"
            />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#16281D]/75 to-transparent px-5 pb-5 pt-16 text-[#F8F7F4]">
              <p className="text-xs font-bold uppercase tracking-[0.18em]">Taşpınar ASM</p>
              <p className="mt-1 font-serif text-xl">Kurum girişi</p>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="border-t border-[#16281D]/15 pt-8"
        data-testid="gallery-grid"
      >
        <div className="mb-8 flex items-center justify-between gap-4">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#4A5D52]">Fotoğraf galerisi</p>
          <p className="font-serif text-lg text-[#16281D]">{GALLERY.images.length} kare</p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-5">
          {GALLERY.images.map((image, i) => (
            <figure
              key={image.src}
              className={`group relative overflow-hidden rounded-xl border border-[#16281D]/10 bg-[#E4E1DA] ${
                image.orientation === "landscape" ? "col-span-2 aspect-[3/2]" : "aspect-[3/4]"
              }`}
            >
            <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.035]"
            />
              <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 bg-gradient-to-t from-[#102017]/85 via-[#102017]/35 to-transparent px-3 pb-3 pt-12 text-[#F8F7F4] sm:px-4 sm:pb-4">
                <span className="text-[10px] font-bold uppercase leading-snug tracking-[0.12em] sm:text-xs">
                  {image.caption}
                </span>
                <span className="shrink-0 font-serif text-base text-[#F8F7F4]/70 sm:text-lg">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
